import { AfterViewInit, Component, OnInit, ViewChild, viewChild } from '@angular/core';
//import { computed } from 'vue';
import { HttpService } from '../shared/services/HttpService';
import { Actuator } from '../shared/models/Actuator';
import { Motor } from '../shared/models/Motor';
import { FeedbackCode } from '../shared/models/FeedbackCode';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Drive } from '../shared/models/Drive';
import { MFG } from '../shared/models/MFG';
import { MatStepper } from '@angular/material/stepper';
import { Cable } from '../shared/models/Cable';
import { ConnectorPin } from '../shared/models/CablePin';
import { faArrowRotateLeft, faArrowRight, faFilePdf, faFileExcel, faGear, faBolt, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { Connector } from '../shared/models/Connector';
import { MatSelectChange } from '@angular/material/select';
import { FeedbackType } from '../shared/models/FeedbackType';
import { FeedbackDevice } from '../shared/models/FeedbackDevice';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit, AfterViewInit {
  @ViewChild('stepper', { static: false }) Stepper!: MatStepper;
  //Stepper = viewChild.required<MatStepper>('stepper');
  CurrentPage: number;
  SelectedLayout: string;
  StartPoint: string;
  SelectedActuator: Actuator;
  SelectedMotor: Motor;
  SelectedFeedback: FeedbackCode;
  SelectedFeedbackDevice: FeedbackDevice;
  SelectedDriveSeries: Drive;
  SelectedDriveSeriesName: string;
  SelectedMFG: MFG;
  Drive_SelectedActuator: Actuator;
  Drive_SelectedMotor: Motor;
  Drive_SelectedFeedback: FeedbackCode;
  Drive_SelectedDriveSeries: Drive;
  Drive_SelectedDriveSeriesName: string;
  Drive_SelectedMFG: MFG;
  Actuator_SelectedActuator: Actuator;
  Actuator_SelectedMotor: Motor;
  Actuator_SelectedFeedback: FeedbackCode;
  Actuator_SelectedDriveSeries: Drive;
  Actuator_SelectedDriveSeriesName: string;
  Actuator_SelectedMFG: MFG;
  TolomaticMFG: MFG;
  SelectedCables: Cable[];
  SelectedConnectors: Connector[];
  Actuators: Actuator[];
  Drive_Actuators: Actuator[];
  Actuator_Actuators: Actuator[];
  Drive_Motors: Motor[];
  Actuator_Motors: Motor[];
  FeedbackCodes: FeedbackCode[];
  Drive_AvailableFeedbackCodes: FeedbackCode[];
  Actuator_AvailableFeedbackCodes: FeedbackCode[];
  Actuator_Drives: Drive[];
  Drive_Drives: Drive[];
  Manufacturers: MFG[];
  Drive_AvailMFGS: MFG[];
  Actuator_AvailMFGS: MFG[];
  Actuator_BrakeSelected: boolean;
  Drive_BrakeSelected: boolean;
  BrakeSelected: boolean;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  fourthFormGroup: FormGroup;
  faArrowRotateLeft = faArrowRotateLeft;
  faArrowRight = faArrowRight;
  faFilePDF = faFilePdf;
  faFileExcel = faFileExcel;
  faGear = faGear;
  faBolt = faBolt;
  faCircleInfo = faCircleInfo;
  PowerCableImage: string;
  FeedbackCableImage: string;
  HybridCableImage: string;
  BrakeCableImage: string;
  ShowTypicalResults: boolean;
  MFGEnabled: boolean;
  Actuator_MotorTooltip: boolean;
  Actuator_FeedbackTooltip: boolean;
  Drive_MotorTooltip: boolean;
  Drive_FeedbackTooltip: boolean;
  HideSuggestedCables: boolean;
  ChangeTracker: boolean[];

  constructor(private http: HttpService, fb: FormBuilder) {
    this.CurrentPage = 0;
    this.SelectedLayout = "wizard";
    this.StartPoint = "";
    this.SelectedMotor = new Motor();
    this.SelectedActuator = new Actuator();
    this.SelectedFeedback = new FeedbackCode();
    this.SelectedFeedbackDevice = new FeedbackDevice();
    this.SelectedDriveSeries = new Drive();
    this.SelectedDriveSeriesName = "";
    this.SelectedMFG = new MFG();
    this.Drive_SelectedMotor = new Motor();
    this.Drive_SelectedActuator = new Actuator();
    this.Drive_SelectedFeedback = new FeedbackCode();
    this.Drive_SelectedDriveSeries = new Drive();
    this.Drive_SelectedDriveSeriesName = "";
    this.Drive_SelectedMFG = new MFG();
    this.Actuator_SelectedMotor = new Motor();
    this.Actuator_SelectedActuator = new Actuator();
    this.Actuator_SelectedFeedback = new FeedbackCode();
    this.Actuator_SelectedDriveSeries = new Drive();
    this.Actuator_SelectedDriveSeriesName = "";
    this.Actuator_SelectedMFG = new MFG();
    this.TolomaticMFG = new MFG();
    this.HideSuggestedCables = false;
    this.SelectedCables = [];
    this.SelectedConnectors = [];
    this.Actuator_BrakeSelected = false;
    this.Drive_BrakeSelected = false;
    this.BrakeSelected = false;
    this.Actuators = [];
    this.Drive_Actuators = [];
    this.Actuator_Actuators = [];
    this.Drive_Motors = [];
    this.Actuator_Motors = [];
    this.FeedbackCodes = [];
    this.Actuator_AvailableFeedbackCodes = [];
    this.Drive_AvailableFeedbackCodes = [];
    this.Actuator_Drives = [];
    this.Drive_Drives = [];
    this.Manufacturers = [];
    this.Drive_AvailMFGS = [];
    this.Actuator_AvailMFGS = [];
    this.firstFormGroup = fb.group({});
    this.secondFormGroup = fb.group({});
    this.thirdFormGroup = fb.group({});
    this.fourthFormGroup = fb.group({});
    this.PowerCableImage = "";
    this.FeedbackCableImage = "";
    this.HybridCableImage = "";
    this.BrakeCableImage = "";
    this.ShowTypicalResults = false;
    this.MFGEnabled = true;
    this.Actuator_MotorTooltip = false;
    this.Actuator_FeedbackTooltip = false;
    this.Drive_MotorTooltip = false;
    this.Drive_FeedbackTooltip = false;
    this.ChangeTracker = [false,false,false,false];
  }
  async ngOnInit() {
    this.StartPoint = "";
    await this.http.LoadMFGs("motor").then(x => {
      this.Manufacturers = x.Content;
      this.TolomaticMFG = this.Manufacturers.filter(x => x.Name == "Tolomatic")[0];
      this.Drive_AvailMFGS = this.Manufacturers;
      this.http.LoadFeedbackCodes().then(y => {
        this.FeedbackCodes = y.Content;

        this.http.LoadActuators().then(z => {
          if (z.StatusCode == "200") {
            this.Actuators = z.Content;
            this.Actuator_Actuators = this.Actuators;            
          }
        });
      });
    });
  }

  async ngAfterViewInit() {
    //this.Stepper = viewChild.required<MatStepper>('stepper');
    //computed(() => {
    //  this.Stepper()._stepHeader.forEach((x) => {
    //    x._elementRef.nativeElement.style.pointerEvents = 'none';
    //  })
    //});
    this.Stepper._stepHeader.forEach((x) => {
      x._elementRef.nativeElement.style.pointerEvents = 'none';
    });
  }

  async NextStep() {
    if (await this.ValidateCurrentStep(this.CurrentPage)) {
      this.CurrentPage++;
      this.ChangeTracker[this.CurrentPage] = false;
      if (this.Stepper != null) {
        this.Stepper.selected!.completed = true;        
      }
      
      this.Stepper.next();
    }
  }

  async PreviousStep() {
    if (this.CurrentPage == 0) {
      return;
    }
    this.CurrentPage--;
    this.ChangeTracker[this.CurrentPage] = false;
    this.Stepper.previous();
  }

  async ValidateCurrentStep(currentStep: number): Promise<boolean> {
    var isValid = false;
    if (this.StartPoint == "actuator") {
      switch (currentStep) {
        case 0:

          isValid = true;
          break;
        case 1:
          await this.http.LoadFeedbackDevice(this.Actuator_SelectedFeedback.Code.substring(3)).then(wrapper => {
            this.SelectedFeedbackDevice = wrapper.Content;
          });
          this.PowerCableImage = this.Actuator_SelectedFeedback.Code.substring(0, 3) + "-Power.png";
          this.FeedbackCableImage = this.Actuator_SelectedFeedback.Code.substring(0, 5) + "-Feedback.png";
          this.HybridCableImage = this.Actuator_SelectedFeedback.Code.substring(0, 5) + "-Hybrid.png";
          if (this.Actuator_SelectedFeedback.Code == "DE2D1") {
            this.BrakeCableImage = "DE2D1-Brake.png";
          }
          else {
            this.BrakeCableImage = "";
          }

          
          if (this.ChangeTracker[this.CurrentPage]) {
            this.Actuator_SelectedDriveSeries = new Drive();
            this.Actuator_SelectedDriveSeriesName = "";
            this.Actuator_SelectedMFG = new MFG();
          }
          if (this.Actuator_SelectedFeedback.Manufacturer.Name == "Tolomatic") {
            this.MFGEnabled = true;
            //need to include MFGs that don't have a feedback code
            var FBCodeMFGRowPointers:string[] = [];
            if (this.Actuator_SelectedActuator.Name.startsWith("IMAS")) {
              FBCodeMFGRowPointers = [...new Set(this.FeedbackCodes.filter(x => !x.Code.startsWith("D")).map(item => item.MFGRowPointer))];
            } else {
              FBCodeMFGRowPointers = [...new Set(this.FeedbackCodes.filter(x => x.Code.startsWith("D")).map(item => item.MFGRowPointer))];
            }
            const FBCodeMFGs = this.Manufacturers.filter(x => FBCodeMFGRowPointers.includes(x.RowPointer));

            //this.Actuator_SelectedMFG.Drives[i].FeedbackTypes.filter(x => x.RowPointer == this.Actuator_SelectedFeedback.FeedbackTypeObject.RowPointer).length > 0

            var nonFBCodeMFGs = this.Manufacturers.filter(x => !FBCodeMFGRowPointers.includes(x.RowPointer) && x.Drives.filter(y => y.FeedbackTypes.filter(z => z.RowPointer == this.Actuator_SelectedFeedback.FeedbackTypeObject.RowPointer).length > 0).length > 0);
            this.Actuator_AvailMFGS = this.Manufacturers.filter(x => x.Name == "Tolomatic");
            this.Actuator_AvailMFGS = this.Actuator_AvailMFGS.concat(nonFBCodeMFGs);

            //this.Actuator_SelectedMFG = this.Actuator_AvailMFGS[0];
            //this.Actuator_Drives = this.Actuator_SelectedMFG.Drives;
            //this.Actuator_SelectedDriveSeries = this.Actuator_Drives[0];
            //this.Actuator_SelectedDriveSeriesName = this.Actuator_SelectedDriveSeries.Series;
            //this.SeriesSelected();
            this.http.GetConnector(this.Actuator_SelectedFeedback.Code, this.Actuator_SelectedMotor.Name).then(wrapper => {
              this.SelectedConnectors = wrapper.Content;
            });

          }
          else {
            this.MFGEnabled = false;
            this.Actuator_AvailMFGS = this.Manufacturers;
            this.Actuator_SelectedMFG = this.Manufacturers.filter(x => x.RowPointer == this.Actuator_SelectedFeedback.Manufacturer.RowPointer)[0];
            
            this.Actuator_Drives = [];
            for (var i = 0; i < this.Actuator_SelectedMFG.Drives.length; i++) {
              if (this.Actuator_SelectedMFG.Drives[i].FeedbackTypes.filter(x => x.RowPointer == this.Actuator_SelectedFeedback.FeedbackTypeObject.RowPointer).length > 0) {
                this.Actuator_Drives.push(this.Actuator_SelectedMFG.Drives[i]);
              }
            }
            //this.Actuator_Drives = this.Actuator_SelectedMFG.Drives.filter(x => x.FeedbackTypes.so.RowPointer == this.Actuator_SelectedFeedback.FeedbackTypeObject.RowPointer);
            //this.Actuator_Drives = this.Actuator_SelectedMFG.Drives;
            //await this.http.GetConnector(this.Actuator_SelectedFeedback.Code, this.Actuator_SelectedMotor.Name).then(wrapper => {
            //  this.SelectedConnectors = wrapper.Content;
            //});
            //await this.http.GetSuggestedCable(this.Actuator_SelectedFeedback.Code, this.Actuator_SelectedDriveSeries.RowPointer, this.Actuator_SelectedMotor.RowPointer, this.Actuator_BrakeSelected).then(wrapper => {
            //  this.SelectedCables = wrapper.Content;
            //});
          }

          isValid = true;
          break;
        case 2:
          
          await this.http.GetConnector(this.Actuator_SelectedFeedback.Code, this.Actuator_SelectedMotor.Name).then(wrapper => {
            this.SelectedConnectors = wrapper.Content;
          });

          
          await this.http.GetSuggestedCable(this.Actuator_SelectedFeedback.Code, this.Actuator_SelectedDriveSeries.RowPointer, this.Actuator_SelectedMotor.RowPointer, this.Actuator_BrakeSelected).then(wrapper => {
            this.SelectedCables = wrapper.Content;
          });

          this.SelectedActuator = this.Actuator_SelectedActuator;
          this.SelectedDriveSeries = this.Actuator_SelectedDriveSeries;
          this.SelectedDriveSeries.MFG = this.Actuator_SelectedMFG;
          this.SelectedDriveSeriesName = this.Actuator_SelectedDriveSeriesName;
          this.SelectedFeedback = this.Actuator_SelectedFeedback;
          if (this.SelectedFeedback.Manufacturer.Name == "Tolomatic") {
            this.SelectedMFG = this.Actuator_AvailMFGS.filter(x => x.RowPointer == this.SelectedFeedback.Manufacturer.RowPointer)[0];
          }
          else {
            this.SelectedMFG = this.Actuator_SelectedMFG;
          }

          this.SelectedMotor = this.Actuator_SelectedMotor;
          this.BrakeSelected = this.Actuator_BrakeSelected;

          this.PowerCableImage = this.Actuator_SelectedFeedback.Code.substring(0, 3) + "-Power.png";
          this.FeedbackCableImage = this.Actuator_SelectedFeedback.Code.substring(0, 5) + "-Feedback.png";
          this.HybridCableImage = this.Actuator_SelectedFeedback.Code.substring(0, 5) + "-Hybrid.png";
          if (this.Actuator_SelectedFeedback.Code == "DE2D1") {
            this.BrakeCableImage = "DE2D1-Brake.png";
          }
          else {
            this.BrakeCableImage = "";
          }

          //this.ShowTypicalResults = true;
          this.HideSuggestedCables = this.SelectedActuator.Name.startsWith("IMAS");
          isValid = true;
          break;
        case 3:
          isValid = false;
          break;
      }
    }
    else if (this.StartPoint == "drive") {
      switch (currentStep) {
        case 0:
          isValid = true;
          break;
        case 1:

          //Need to display only feedback codes that are valid for the selected drive series
          this.Drive_Actuators = this.Actuators;
          //this.Drive_SelectedDriveSeries = this.Drive_Drives.filter(x => x.Series == event.value)[0];
          
          this.SelectedDriveSeriesName = this.Drive_SelectedDriveSeries.Series;
          if (this.ChangeTracker[this.CurrentPage]) {
            this.Drive_SelectedActuator = new Actuator();
            this.Drive_SelectedMotor = new Motor();
            this.Drive_SelectedFeedback = new FeedbackCode();
          }
          
          isValid = true;
          break;
        case 2:
          await this.http.GetConnector(this.Drive_SelectedFeedback.Code, this.Drive_SelectedMotor.Name).then(wrapper => {
            this.SelectedConnectors = wrapper.Content;
          });

          await this.http.GetSuggestedCable(this.Drive_SelectedFeedback.Code, this.Drive_SelectedDriveSeries.RowPointer, this.Drive_SelectedMotor.RowPointer, this.Drive_BrakeSelected).then(wrapper => {
            this.SelectedCables = wrapper.Content;
          });

          await this.http.LoadFeedbackDevice(this.Drive_SelectedFeedback.Code.substring(3)).then(wrapper => {
            this.SelectedFeedbackDevice = wrapper.Content;
          });
          this.SelectedActuator = this.Drive_SelectedActuator;
          this.SelectedDriveSeries = this.Drive_SelectedDriveSeries;
          this.SelectedDriveSeries.MFG = this.Drive_SelectedMFG;
          this.SelectedDriveSeriesName = this.Drive_SelectedDriveSeriesName;
          this.SelectedFeedback = this.Drive_SelectedFeedback;
          if (this.SelectedFeedback.Manufacturer.Name == "Tolomatic") {
            this.SelectedMFG = this.Drive_AvailMFGS.filter(x => x.RowPointer == this.SelectedFeedback.Manufacturer.RowPointer)[0];
            this.MFGEnabled = true;
          }
          else {
            this.SelectedMFG = this.Drive_SelectedMFG;
            this.MFGEnabled = false;
          }

          this.SelectedMotor = this.Drive_SelectedMotor;
          this.BrakeSelected = this.Drive_BrakeSelected;
          this.PowerCableImage = this.Drive_SelectedFeedback.Code.substring(0, 3) + "-Power.png";
          this.FeedbackCableImage = this.Drive_SelectedFeedback.Code.substring(0, 5) + "-Feedback.png";
          this.HybridCableImage = this.Drive_SelectedFeedback.Code.substring(0, 5) + "-Hybrid.png";
          if (this.Drive_SelectedFeedback.Code == "DE2D1") {
            this.BrakeCableImage = "DE2D1-Brake.png";
          }
          else {
            this.BrakeCableImage = "";
          }
          this.HideSuggestedCables = this.SelectedActuator.Name.startsWith("IMAS");
          isValid = true;
          break;
        case 3:
          isValid = false;
          break;
      }
    }

    return isValid;
  }

  async SelectStartPoint(startPoint: string) {
    this.StartPoint = startPoint;
  }

  LayoutChange() {
    var tempLayout = this.SelectedLayout;
    this.ResetSelections();
    this.SelectedLayout = tempLayout;
  }

  ResetSelections() {
    this.ChangeTracker = [false, false, false, false];
    this.CurrentPage = 0;
    this.Stepper.reset();
    this.StartPoint = "";
    this.Drive_SelectedActuator = new Actuator();
    this.Actuator_SelectedActuator = new Actuator();
    this.SelectedCables = [];
    this.Drive_SelectedFeedback = new FeedbackCode();
    this.Actuator_SelectedFeedback = new FeedbackCode();
    this.SelectedLayout = "wizard";
    this.Drive_SelectedMFG = new MFG();
    this.Actuator_SelectedMFG = new MFG();
    this.Drive_SelectedMotor = new Motor();
    this.Actuator_SelectedMotor = new Motor();
    this.Drive_SelectedDriveSeries = new Drive();
    this.Actuator_SelectedDriveSeries = new Drive();
    this.Drive_SelectedDriveSeriesName = "";
    this.Actuator_SelectedDriveSeriesName = "";
    this.Drive_Drives = [];
    this.Actuator_Drives = [];
    this.Drive_Actuators = [];
    this.Actuator_AvailMFGS = [];
    this.Drive_Motors = [];
    this.Actuator_Motors = [];
    this.Actuator_AvailableFeedbackCodes = [];
    this.Drive_AvailableFeedbackCodes = [];
    this.Actuator_BrakeSelected = false;
    this.Drive_BrakeSelected = false;
    this.BrakeSelected = false;

    this.PowerCableImage = "";
    this.FeedbackCableImage = "";
    this.HybridCableImage = "";
    this.ShowTypicalResults = false;
    this.MFGEnabled = true;
  }

  ClearSideSelections(side: string) {
    this.MFGEnabled = true;
    if (side == "drive") {
      this.Drive_AvailableFeedbackCodes = [];
      this.Drive_Drives = [];
      this.Drive_Motors = [];
      this.Drive_Actuators = [];
      this.Drive_SelectedActuator = new Actuator();
      this.Drive_SelectedDriveSeries = new Drive();
      this.Drive_SelectedDriveSeriesName = "";
      this.Drive_SelectedFeedback = new FeedbackCode();
      this.Drive_SelectedMFG = new MFG();
      this.Drive_SelectedMotor = new Motor();
      this.Drive_BrakeSelected = false;
    }
    else if (side == "actuator") {
      this.Actuator_AvailableFeedbackCodes = [];
      this.Actuator_AvailMFGS = [];
      this.Actuator_Drives = [];
      this.Actuator_Motors = [];
      this.Actuator_SelectedActuator = new Actuator();
      this.Actuator_SelectedDriveSeries = new Drive();
      this.Actuator_SelectedDriveSeriesName = "";
      this.Actuator_SelectedFeedback = new FeedbackCode();
      this.Actuator_SelectedMFG = new MFG();
      this.Actuator_SelectedMotor = new Motor();
      this.Actuator_BrakeSelected = false;
    }
    this.ChangeTracker = [false, false, false, false];
  }

  async ActuatorSelected(startPoint: string) {
    //Load Motors
    if (this.StartPoint == "" && this.SelectedLayout == "typical") {
      this.StartPoint = startPoint;
    } else if (this.StartPoint != "" && this.StartPoint != startPoint) {
      this.ClearSideSelections(this.StartPoint);
      this.StartPoint = startPoint;
    }

    if (this.StartPoint == "drive") {
      this.ChangeTracker[this.CurrentPage] = true;
      this.Drive_Motors = this.Drive_SelectedActuator.Motors.filter(x => x.ContinStallCurrent < this.Drive_SelectedDriveSeries.MaxOutputCurrent && x.BusVoltage < this.Drive_SelectedDriveSeries.MaxInputVoltage);
      this.Drive_AvailableFeedbackCodes = [];
      this.Drive_SelectedFeedback = new FeedbackCode();
      
    }
    else {
      this.ChangeTracker[this.CurrentPage] = true;
      this.Actuator_Motors = this.Actuator_SelectedActuator.Motors;
      this.Actuator_AvailableFeedbackCodes = [];
      this.Actuator_SelectedFeedback = new FeedbackCode();
    }
  }

  async MotorSelected() {
    //Load Feedback codes
    this.ChangeTracker[this.CurrentPage] = true;
    if (this.StartPoint == "drive") {      
      var validFeedback = this.Drive_SelectedDriveSeries.FeedbackTypes;

      if (this.Drive_SelectedActuator.Name.startsWith("IMAS")) {
        this.Drive_AvailableFeedbackCodes = this.FeedbackCodes.filter(x => (x.Code.startsWith("C") || x.Code.startsWith("F")) && x.MFGRowPointer == this.Drive_SelectedMFG.RowPointer && validFeedback.filter(y => y.RowPointer == x.FeedbackTypeObject.RowPointer).length > 0)
        if (this.Drive_AvailableFeedbackCodes.length == 0) {
          this.Drive_AvailableFeedbackCodes = this.FeedbackCodes.filter(x => (x.Code.startsWith("C") || x.Code.startsWith("F")) && x.Manufacturer.Name == "Tolomatic" && validFeedback.filter(y => y.RowPointer == x.FeedbackTypeObject.RowPointer).length > 0);
        }   
        
      } else {
        this.Drive_AvailableFeedbackCodes = this.FeedbackCodes.filter(x => x.Code.startsWith("D") && x.MFGRowPointer == this.Drive_SelectedMFG.RowPointer && validFeedback.filter(y => y.RowPointer == x.FeedbackTypeObject.RowPointer).length > 0)
        if (this.Drive_AvailableFeedbackCodes.length == 0) {//Must be B&R, Yaskawa,Kollmorgen.  Just show Tolomatic feedback codes
          this.Drive_AvailableFeedbackCodes = this.FeedbackCodes.filter(x => x.Code.startsWith("D") && x.Manufacturer.Name == "Tolomatic" && validFeedback.filter(y => y.RowPointer == x.FeedbackTypeObject.RowPointer).length > 0);
        }
      }
     
    }
    else {      
      this.Actuator_AvailableFeedbackCodes = this.FeedbackCodes;

      if (this.Actuator_SelectedActuator.Name.startsWith("IMAS")) {
        this.Actuator_AvailableFeedbackCodes = this.Actuator_AvailableFeedbackCodes.filter(x => x.Code.startsWith("C") || x.Code.startsWith("F"));
      } else {
        this.Actuator_AvailableFeedbackCodes = this.Actuator_AvailableFeedbackCodes.filter(x => x.Code.startsWith("D"));
      }
    }
  }

  async FeedbackSelected() {
    this.ChangeTracker[this.CurrentPage] = true;
    //this.SelectedMFG = new MFG();
    if (this.StartPoint == "actuator") {
      
    }
    else {
      
    }

  }

  async LayoutSelected(layout: string) {
    this.SelectedLayout = layout;
  }

  async MFGSelected(startPoint: string) {
    this.ChangeTracker[this.CurrentPage] = true;
    if (this.StartPoint == "" && this.SelectedLayout == "typical") {
      this.StartPoint = startPoint;
    } else if (this.StartPoint != "" && this.StartPoint != startPoint) {
      this.ClearSideSelections(this.StartPoint);
      this.StartPoint = startPoint;
    }


    if (this.StartPoint == "actuator") {
      this.Actuator_Drives = this.Actuator_SelectedMFG.Drives;
      if (this.Actuator_SelectedMFG.Name != "Tolomatic") {
        this.Actuator_Drives = [];
        for (var i = 0; i < this.Actuator_SelectedMFG.Drives.length; i++) {
          if (this.Actuator_SelectedMFG.Drives[i].FeedbackTypes.filter(x => x.RowPointer == this.Actuator_SelectedFeedback.FeedbackTypeObject.RowPointer).length > 0) {
            this.Actuator_Drives.push(this.Actuator_SelectedMFG.Drives[i]);
          }
        }

      }
      else {
        this.Actuator_SelectedDriveSeries = this.Actuator_Drives[0];
        this.Actuator_SelectedDriveSeriesName = this.Actuator_SelectedDriveSeries.Series;
        
        this.SeriesSelected();
      }
    }
    else {
      this.Drive_Drives = this.Drive_SelectedMFG.Drives;
      if (this.Drive_SelectedMFG.Name != "Tolomatic") {
        //this.Drive_SelectedDriveSeries = this.Drive_Drives.filter(x => x.MFG.RowPointer == this.Drive_SelectedMFG.RowPointer && x.FeedbackType == this.Drive_SelectedFeedback.FeedbackTypeObject.Type)[0];
      }
      else {
        this.Drive_SelectedDriveSeries = this.Drive_Drives[0];
        this.Drive_SelectedDriveSeriesName = this.Drive_SelectedDriveSeries.Series;
        this.SeriesSelected();
      }
    }
  }

  async SeriesSelected() {
    this.ChangeTracker[this.CurrentPage] = true;
    if (this.StartPoint == "drive") {

      
    }
    else if (this.StartPoint == "actuator") {
     
    }


  }

  GetSpecificCable(cType: string): Cable {
    if (this.SelectedCables.some(x => x.CableType == cType)) {
      return this.SelectedCables.filter(x => x.CableType == cType)[0];
    }
    else {
      return new Cable();
    }
  }

  GetSpecificConnector(cableType: string): Connector {
    if (this.SelectedConnectors.some(x => x.CableType == cableType)) {
      return this.SelectedConnectors.filter(x => x.CableType == cableType)[0];
    } else {
      return new Connector();
    }
  }

  GetSpecificConnectorPins(cType: string): ConnectorPin[] {
    if (this.SelectedConnectors.some(x => x.CableType == cType)) {
      var pins = this.SelectedConnectors.filter(x => x.CableType == cType)[0].Pins;
      return pins;
    }
    else {
      return [];
    }
  }

  getUniqueDriveSeries(drives: Drive[]): string[] {

    const retArray = drives.map(x => x.Series);

    const unique = new Set(retArray);
    const uniqueArray = [...unique];

    return uniqueArray.sort();
  }

  getFBCodeMFGs(fbCodes: FeedbackCode[]) {
    var mfgs:MFG[] = [];
    for (var i = 0; i < fbCodes.length; i++) {
      if (!mfgs.some(x => x.RowPointer == fbCodes[i].Manufacturer.RowPointer)) {
        mfgs.push(fbCodes[i].Manufacturer);
      }
    }

    return mfgs;
  }

  getFBCodeFromMFG(mfg: MFG) {
    if (this.StartPoint == "actuator") {      
      return this.Actuator_AvailableFeedbackCodes.filter(x => x.Manufacturer.RowPointer == mfg.RowPointer);
    }
    else {
      var validFeedback = this.Drive_SelectedDriveSeries.FeedbackTypes;
      return this.Drive_AvailableFeedbackCodes.filter(x => x.Manufacturer.RowPointer == mfg.RowPointer && validFeedback.filter(y => y.RowPointer == x.FeedbackTypeObject.RowPointer).length > 0);
    }
    
  }

  Tooltip_Click(whichTooltip: string) {

    if (whichTooltip == "Actuator_MotorTooltip") {
      this.Actuator_FeedbackTooltip = false;
      this.Drive_MotorTooltip = false;
      this.Drive_FeedbackTooltip = false;
      this.Actuator_MotorTooltip = !this.Actuator_MotorTooltip;
    } else if (whichTooltip == "Actuator_FeedbackTooltip") {
      this.Actuator_MotorTooltip = false;
      this.Drive_MotorTooltip = false;
      this.Drive_FeedbackTooltip = false;
      this.Actuator_FeedbackTooltip = !this.Actuator_FeedbackTooltip;
    } else if (whichTooltip == "Drive_MotorTooltip") {
      this.Actuator_FeedbackTooltip = false;
      this.Actuator_MotorTooltip = false;
      this.Drive_FeedbackTooltip = false;
      this.Drive_MotorTooltip = !this.Drive_MotorTooltip;
    } else if (whichTooltip == "Drive_FeedbackTooltip") {
      this.Actuator_FeedbackTooltip = false;
      this.Actuator_MotorTooltip = false;
      this.Drive_MotorTooltip = false;
      this.Drive_FeedbackTooltip = !this.Drive_FeedbackTooltip;
    }    
  }

}
